export default "__VITE_ASSET__Cy6$mt2x__"